"use client";

import type { ReactNode } from "react";
import { requestContact } from "@/app/contact/contact-prefill";

type Variant = "primaryOnNavy" | "outlineOnNavy";

function classesFor(variant: Variant) {
  const base =
    "inline-flex items-center justify-center gap-2 font-semibold transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";
  switch (variant) {
    case "primaryOnNavy":
      return `${base} rounded-lg bg-brand-cyan px-5 py-3 text-label-md text-brand-navy hover:bg-[#00c2c2] focus-visible:outline-brand-cyan`;
    case "outlineOnNavy":
      return `${base} rounded-lg border border-white/25 px-5 py-3 text-label-md text-white hover:bg-white/10 focus-visible:outline-brand-cyan`;
  }
}

/** Scrolls to the enquiry form; optionally pre-selects a Subject. */
export function ContactCtaButton({
  variant,
  subject,
  children,
}: {
  variant: Variant;
  subject?: string;
  children: ReactNode;
}) {
  return (
    <button type="button" onClick={() => requestContact(subject)} className={classesFor(variant)}>
      {children}
    </button>
  );
}

/** An "area we can help with" row that pre-selects the matching Subject. */
export function HelpTopicRow({
  icon,
  title,
  description,
  subject,
}: {
  icon: ReactNode;
  title: string;
  description: string;
  subject: string;
}) {
  return (
    <button
      type="button"
      onClick={() => requestContact(subject)}
      className="group flex w-full gap-3.5 p-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand-electric"
    >
      <span className="mt-0.5 shrink-0 text-brand-electric">{icon}</span>
      <span>
        <span className="block text-sm font-semibold text-brand-navy group-hover:text-brand-electric">
          {title}
        </span>
        <span className="mt-1 block text-sm leading-6 text-on-surface-variant">{description}</span>
      </span>
    </button>
  );
}
